import { InviteAdminModal } from "../users/InviteAdminModal";

interface Props {
  open: boolean;
  onClose: () => void;
}

/**
 * "New invite" modal launched from the Invites page header. Reuses the
 * platform-wide `InviteAdminModal` so the create flow is identical between
 * Platform › Users and Platform › Invites (mockup L291-L294).
 *
 * Kept as a thin alias so callers in `features/invites/*` don't have to
 * cross-feature-import — and so future Invite-specific tweaks can land here.
 */
export function NewInviteModal({ open, onClose }: Props) {
  return <InviteAdminModal open={open} onClose={onClose} />;
}
